<script lang="ts" setup>
  import { useHttpClient, useRoute } from '@othercommerce/foundation';
  import { ref } from 'vue';

  const loading = ref(false);
  const resent = ref(false);
  const http = useHttpClient();
  const route = useRoute();


  function actionResend() {
    loading.value = true;
    http.post(route('web.account.verify.resend'));
    resent.value = true;
    loading.value = false;
  }


  function actionLogout() {
    loading.value = true;
    http.delete(route('web.account.session.destroy'));
  }
</script>
<template>
  <main id="main" class="verify">
    <SfTile large>
      <template #title>
        <h1 class="account-heading verify__heading">
          {{ $t('SHOP.AUTH.HEADER.VERIFY_EMAIL') }}
        </h1>
      </template>
      <template #default>
        <div class="verify__message">
          <p class="verify__text">{{ $t('SHOP.AUTH.MESSAGE.VERIFY_EMAIL_1') }}</p>
          <p class="verify__text">{{ $t('SHOP.AUTH.MESSAGE.VERIFY_EMAIL_2') }}</p>
        </div>
        <div class="verify__resend">
          <SfButton @click="actionLogout">
            <template #before>
              <SfIconPower aria-hidden="true" />
            </template>
            <template #default>
              {{ $t('SHOP.AUTH.ACTION.SIGN_OUT') }}
            </template>
          </SfButton>
          <SfButton :disabled="resent" :loading="loading" primary @click="actionResend">
            {{ resent ? $t('SHOP.AUTH.ACTION.VERIFY_EMAIL_LINK_SENT') : $t('SHOP.AUTH.ACTION.VERIFY_EMAIL_LINK_RESEND') }}
          </SfButton>
        </div>
      </template>
    </SfTile>
  </main>

  <RouterView />
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  .verify {
    width: 98%;
    max-width: 1200px;
    margin: 100px auto;

    &__message {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      line-height: 1.5;
    }

    &__resend {
      display: flex;
      gap: 2rem;
      justify-content: flex-end;
      margin-top: 2rem;
    }
  }

  @include media.query(lg) {
    .verify {
      margin: 50px auto;
      text-align: center;

      .tile__content {
        padding: 1.5rem 0.625rem;

        .tile__header {
          justify-content: center;
        }
      }

      &__header {
        margin-bottom: 0.625rem;
      }


      &__heading {
        font-size: 1.375rem;
        text-align: center;
      }

      &__resend {
        flex-direction: column;
        gap: 1rem;
        align-items: stretch;
        margin-top: 1rem;
      }
    }
  }
</style>
